import React from "react";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import { get, includes, toUpper, filter } from "lodash";
import Grid from "@material-ui/core/Grid";

import { fetchPost } from "../../../api/fetch";
import ProfileLink from "../../Common/ProfileLink";
import TemperatureDetails from "../Temperature/TemperatureDetails";
import { human } from "../../../constants/common";
import { eventGroupsData } from "../../../constants/eventGroups";
import images from "../../../assets/img/images";
import InfoSection from "../../Common/InfoSection";
import {
  displayedTemperature,
  getDisplayedTemperatureAttr,
  getFinalTemperature,
  getMeasureType,
  getThreshold,
  isOverThreshold,
} from "../../../utils/temperature";
import AddTemperature from "../../Profiles/AddTemperature";
import { getAttributeValue } from "../../../utils/profile";
import { formatDate } from "../../../utils/date";

const LogDetailsTemperatureNew = (props) => {
  const {
    powerUserMode,
    log,
    language,
    identificationEventGroup,
    overriden,
    lov = {},
  } = props;

  const [temperatureEventGroup, setTemperatureEventGroup] = React.useState();

  React.useEffect(() => {
    fetchTemperatureEventGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [get(log, ["id"])]);

  const fetchTemperatureEventGroup = async () => {
    try {
      let res = await fetchPost("new/event_groups", {
        filter: {
          parent_ids: [get(log, ["id"])],
          types: [13],
        },
        data: eventGroupsData,
      });
      setTemperatureEventGroup(get(res, ["items", 0]));
    } catch (e) {
      console.log(e);
    }
  };

  const mainEvent = get(
    filter(
      get(log, ["events"]),
      (e) => e.active && includes([58, 59], get(e, ["type", "id"]))
    ),
    [0]
  );

  const [finalTemp, finalTempEvent] = getFinalTemperature(
    temperatureEventGroup
  );
  const measureType = getMeasureType(finalTempEvent);
  const attr = getDisplayedTemperatureAttr(measureType);
  const fever = isOverThreshold(
    finalTemp,
    getThreshold(get(log, ["measuredTemperature"]))
  );

  const onSubmitTemperature = async (tempEventGroup, tempEvent) => {
    try {
      let tempEventGroupId = get(temperatureEventGroup, ["id"]);
      if (!tempEventGroupId) {
        tempEventGroup.parent_id = get(log, ["id"]);
        let eventGroup = await fetchPost("event_groups", tempEventGroup);
        tempEventGroupId = get(eventGroup, ["id"]);
      }
      tempEvent.event_group_id = tempEventGroupId;
      await fetchPost("events", tempEvent);
      fetchTemperatureEventGroup();
      if (props.refreshLog) {
        props.refreshLog();
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Grid container direction="column">
      <ProfileLink
        profile={get(identificationEventGroup, ["profile"])}
        score={get(identificationEventGroup, ["luke_index"])}
        overriden={overriden}
        type={human}
        disabled={props.blockLevel2}
      />
      <Grid item style={{ margin: "24px 16px 0px" }}>
        <Grid container>
          <InfoSection
            title2={I18n.get("site_siteAndZone")}
            values={[
              `${get(mainEvent, ["zone", "site", "name"])}/${get(mainEvent, [
                "zone",
                "name",
              ])}`,
            ]}
            style={{ marginRight: "50px" }}
          />
          <InfoSection
            title2={I18n.get("profiles_dateTime")}
            values={[
              formatDate(
                getAttributeValue(mainEvent, 76) ||
                getAttributeValue(mainEvent, 77)
              ),
            ]}
            style={{ marginRight: "50px" }}
          />
          {powerUserMode && (
            <InfoSection
              title2={I18n.get("events_eventGroupId")}
              values={[get(log, ["id"])]}
            />
          )}
        </Grid>
      </Grid>
      <Grid item style={{ margin: "20px 24px 0px" }}>
        <div className="bold-500">
          {toUpper(I18n.get("site_finalTemperature"))}
        </div>
        {finalTemp ? (
          <Grid container alignItems="center">
            <Grid item className="flexCenter" style={{ marginRight: "7px" }}>
              <img
                src={
                  fever
                    ? images.temperatureButtonRed
                    : images.temperatureButtonGreen
                }
                alt="temperature_status"
              />
            </Grid>
            <Grid item style={{ fontSize: "1.857em" }}>
              {displayedTemperature(finalTempEvent, attr, lov)}
            </Grid>
          </Grid>
        ) : null}
        <div style={{ margin: "12px 6px" }}>
          <AddTemperature
            profile={get(mainEvent, ["profile"])}
            language={language}
            onSubmit={onSubmitTemperature}
            open={props.addTempDirectly}
          />
        </div>
      </Grid>
      <Grid item style={{ margin: "10px 0px" }}>
        <TemperatureDetails
          profileId={get(identificationEventGroup, ["profile", "id"])}
          currentTemperature={temperatureEventGroup}
          language={language}
          maxWidth={"calc(100vw - 214px)"}
          blockLevel2={props.blockLevel2}
          logDetailsDisplay
        />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    powerUserMode: get(state, ["common", "powerUserModeEnabled"]),
  };
};

export default connect(mapStateToProps)(LogDetailsTemperatureNew);
